import React, { Component } from 'react';
import { connect } from "react-redux";
import { setList } from "../../Actions/endUserActions";


import axios from "axios";
import { ActionAddMedia, ActionAddReminder, ActionClose, VehicleReminderAdd } from '../Common/Buttons/Icons';

//A React component will allow us to quickly iterate and change our code. It provides 
class EUMediaCard extends Component {
    constructor(props) {
        super(props);

        this.addMedia = this.addMedia.bind(this);
        this.setReminder = this.setReminder.bind(this);
        this.dismiss = this.dismiss.bind(this);

        this.state = {
        };
    }

    addMedia() {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push('/' + base_url + '/media/' + this.props.booking.BOOK_ID + '/create');
    }

    setReminder() {
        var base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/media_reminder/' + this.props.booking.BOOK_ID);
    }

    dismiss() {
        var self = this;
        axios.get('/ajax/media_reminders/dismissUser/' +  this.props.booking.BOOK_ID)
        .then(function(response) {
            var outstanding_bookings = self.props.endUser.outstanding_bookings
            var dismissed_bookings = self.props.endUser.dismissed_bookings
        
            for (var i = 0; i < outstanding_bookings.length; i++) {
                if (outstanding_bookings[i].BOOK_ID === self.props.booking.BOOK_ID) {
                    var booking = outstanding_bookings[i]
                    if (dismissed_bookings) {
                        dismissed_bookings.push(booking)
                    }
                    outstanding_bookings.splice(i, 1)
                }
            }
    
            self.props.dispatch(setList("SET_OUTSTANDING_BOOKINGS_LIST", outstanding_bookings))
            self.props.dispatch(setList("SET_DISMISSED_BOOKINGS_LIST", dismissed_bookings))
    
            axios.get('/ajax/eu-media/outstanding')
            .then(function(response2) {
                self.props.dispatch(setList("SET_OUTSTANDING_BOOKINGS_LIST", response2.data))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    
            axios.get('/ajax/eu-media/dismissed')
            .then(function(response2) {
                self.props.dispatch(setList("SET_DISMISSED_BOOKINGS_LIST", response2.data))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })

            showStatusMsg(response?.data.message, 'success')
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render() {
        return (
            <div className = "columns large-4 medium-6 small-12">
                <div className = "card eu-booking-card">
                    <div className = "eu-booking-vehicle-image">
                        <img src = {this.props.img} />
                    </div>
                    <div className = "eu-booking-info">
                        <div className = "veh-name">
                            <div className = "row collapse p-16 border-bottom">
                                <h4 className = "mb-4"> {this.props.year} {this.props.make} {this.props.model} {this.props.trim}</h4>
                                <span className = "black-light">{this.props.pickupdate} – {this.props.dropoffdate}</span>
                            </div>
                        </div>
                        <div className = "ml-16 mr-16 mt-12">
                            {
                                this.props.type === "OUTSTANDING" || this.props.type === "DISMISSED" ?
                                    <a className = "float-left mr-8" data-tooltip tabIndex = "1" title = "Add Media" data-position="bottom" data-alignment = "center" onClick={this.addMedia} style = {{padding:'5px 6px'}}>
                                        {ActionAddMedia()}
                                    </a>
                                :
                                    null
                            }
                            {
                                this.props.type === "OUTSTANDING" || this.props.type === "DISMISSED" ?
                                    <a className = "float-left mr-8" data-tooltip tabIndex = "1" title = "Add Reminder" data-position="bottom" data-alignment = "center" onClick={this.setReminder} style = {{padding:'5px 6px', paddingLeft: '10px', height: '48px', width: '48px'}}>
                                        {ActionAddReminder()}
                                    </a>
                            :
                                null
                            }
                            {
                                this.props.type === "OUTSTANDING" ?
                                    <a className = "float-left mr-8" data-tooltip tabIndex = "1" title = "Dismiss" data-position="bottom" data-alignment = "center" onClick={this.dismiss} style = {{padding:'5px 6px'}}>
                                        {ActionClose()}
                                    </a>
                            :
                                null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
});

export default connect(mapStateToProps)(EUMediaCard);